<template>
	<div id="app">
		<Header/>
		<router-view/>
		<Footer/>
	</div>
</template>

<script>
	import Header from "./components/Header";
	import Footer from "./components/Footer";
	import {api} from "./mixins/axios";


	export default {
		components: {
			Header,
			Footer,
		},
		mounted() {
			let externalScript = document.createElement('script')
			externalScript.setAttribute('src', '/scripts/log.js')
			document.head.appendChild(externalScript);
			setTimeout(function() {
			if(location.origin === "https://duckist.com") {
				sendLogs("https://api.duckist.com/event/l", "page_visit", getLog());
			} else {
				sendLogs("https://1api.duckist.com/event/l", "page_visit", getLog());
			}}, 2000);
		},
		watch:{
			$route (to, from){
				setTimeout(function () {
					if (location.origin === "https://duckist.com") {
						sendLogs("https://api.duckist.com/event/l", "page_visit", getLog());
					} else {
						sendLogs("https://1api.duckist.com/event/l", "page_visit", getLog());
					}
				}, 2000);

			}
		}
	};
</script>

<style lang="scss">
	@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap');
	@import "./assets/scss/mixins.scss";

	html, body {
		height: 100%;
	}

	#app {
		font-family: "Montserrat", sans-serif;
		height: 100%;
	}
</style>
